import React, { useState } from 'react';
import Modal from 'react-modal';
import sampleImageURL from '../../../assets/oxygen reliable post 2.png';
import './guideModal.css';

const GuideModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const storeLink = 'https://lifebank.ng/order.php'; // Replace the URL here

  return (
    <div className="sp">
      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        appElement={document.getElementById('root')}
        onRequestClose={closeModal}
        className="modal-content"
        overlayClassName="ReactModal__Overlay"
      >
        <div className="close" onClick={closeModal}>
          &times;
        </div>
        <a href={storeLink} target="_blank" rel="noopener noreferrer">
          <img src={sampleImageURL} alt="Modal" className="modal-image" />
        </a>
      </Modal>
    </div>
  );
};

export default GuideModal;


